export const SERVICE_BASIC = {
    WEEKS: 'Weeks',
    MILES: 'Miles',
    ALL: 'All'
};